import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import UserInfoReducer from "../reducers/user_info/userInfoReducer";
import moveInfoReducer from "../reducers/move_info/moveInfoReducer";
import propertyInfoReducer from "../reducers/property_info/propertyInfoReducer";
import inventoryReducer from "../reducers/inventory/inventoryReducer";
import progressReducer from "../reducers/progress/progressReducer";
import storageProgressReducer from "../reducers/storage_progress/progressReducer";
import storageMoveInfo from "../reducers/storage_moveinfo/moveInfoReducer";

// Redux dev tools
const composeTools =
  process.env.REACT_APP_ENVIRONMENT === "dev"
    ? composeWithDevTools(applyMiddleware(thunk))
    : compose(applyMiddleware(thunk));

// Root Reducer
export const rootReducer = combineReducers({
  userInfo: UserInfoReducer,
  moveInfo: moveInfoReducer,
  propertyInfo: propertyInfoReducer,
  inventoryInfo: inventoryReducer,
  progressInfo: progressReducer,
  storageProgressInfo: storageProgressReducer,
  storageMoveInfo: storageMoveInfo,
});

// Store
export const store = createStore(rootReducer, composeTools);